import React, { useEffect, useMemo, useRef } from 'react';
import LocalOpsSheet from './LocalOpsSheet';

const formatPrice = (price = {}) =>
  price.display ||
  (price.amountCents ? `$${(price.amountCents / 100).toFixed(2)}` : '$9.99');

export default function LocalOpsFoundingHelperPassModal({
  open,
  offer,
  busy = false,
  error = '',
  onPrimary,
  onSkip,
  onDismiss,
}) {
  const primaryRef = useRef(null);
  const region = offer?.regionDisplayName || 'Local';
  const offerName = offer?.offerName || `${region} Founding Helper Pass`;
  const priceLabel = useMemo(() => formatPrice(offer?.price), [offer?.price]);

  useEffect(() => {
    if (!open) return undefined;
    const raf = requestAnimationFrame(() => {
      primaryRef.current?.focus?.();
    });
    return () => cancelAnimationFrame(raf);
  }, [open]);

  return (
    <LocalOpsSheet
      open={open}
      onClose={onDismiss}
      title={offerName}
      ariaLabel={offerName}
      className="localops-sheet--centered localops-founding-pass"
    >
      <div className="localops-founding-pass__body">
        <p>Lock in early {region} helper access while the launch window is open.</p>
        <p>
          Founding helpers get early access as the {region} LocalOps network
          develops. Join now, stay close to the launch, and be ready when local
          work starts moving.
        </p>
        <p>
          One-time launch price: {priceLabel}
        </p>
      </div>

      {error ? (
        <div className="localops-founding-pass__error" role="alert">
          {error}
        </div>
      ) : null}

      <div className="localops-founding-pass__actions">
        <button
          type="button"
          className="localops-btn localops-founding-pass__primary"
          onClick={onPrimary}
          disabled={busy}
          ref={primaryRef}
        >
          {busy ? 'Opening Stripe...' : `Lock in my Founding Pass - ${priceLabel}`}
        </button>
        <button
          type="button"
          className="localops-btn localops-btn--ghost localops-founding-pass__secondary"
          onClick={onSkip}
          disabled={busy}
        >
          Continue without a pass
        </button>
      </div>

      <div className="localops-founding-pass__small-print">
        No subscription. The pass is optional - you can continue without one.
      </div>
    </LocalOpsSheet>
  );
}
